<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> nodo  {{LOCAL_DATA?.nombre || LOCAL_DATA?.name}}</h1>
<div mat-dialog-content fxLayout="column">

  <div fxFlex *ngIf="action != 'View'">
    <mat-form-field fxFlex>
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" >
    </mat-form-field>
  </div>
  <div fxFlex *ngIf="action != 'View'">
    <mat-form-field fxFlex>
      <textarea placeholder="Descripcion" matInput [(ngModel)]="LOCAL_DATA.descripcion" [disabled]="action == 'View'"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex *ngIf="action != 'View'">
    <mat-form-field fxFlex>
      <mat-chip-list #chipList aria-label="Usuarios">
        <mat-chip
          *ngFor="let usuario of LOCAL_DATA.usuarios"
          [selectable]="selectable"
          [removable]=true
          (removed)="remove(usuario)">
          {{usuario.nombreCompleto}}
          <mat-icon matChipRemove >cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Usuarios"
          #usuarioInput
          [formControl]="usuarioCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [disabled]="action == 'View'"
          >
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let usuario of filteredUsuarios | async" [value]="usuario">
          {{usuario.nombreCompleto}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>


  <mat-tab-group animationDuration="0ms" >
    <mat-tab label="Usuarios">
        <div class="content p-24" fxFlex>

          <table mat-table [dataSource]="LOCAL_DATA.usuarios" #mytablePreiniciado class="my-table mat-elevation-z8" fxFlex>

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef> Nombre </th>
              <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
            </ng-container>
            <ng-container matColumnDef="apellido">
              <th mat-header-cell *matHeaderCellDef> Apellido </th>
              <td mat-cell *matCellDef="let element"> {{element.apellido}} </td>
            </ng-container>

            <!-- User Column -->
            <ng-container matColumnDef="correoElectronico">
              <th mat-header-cell *matHeaderCellDef> Usuario </th>
              <td mat-cell *matCellDef="let element"> {{element.correoElectronico}} </td>
            </ng-container>

            <!-- Role Column -->
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef> Perfiles </th>
              <td mat-cell *matCellDef="let element">
                <mat-chip-list aria-label="Tipos de usuario">
                  <mat-chip *ngFor="let tipo of element.tipos">{{tipo.nombre}}</mat-chip>
                </mat-chip-list>
              </td>
              <!--<td mat-cell *matCellDef="let element"> {{element.tipo?.nombre}} </td>-->
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumnsUsuarios"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsUsuarios;"></tr>
          </table>
        </div>


    </mat-tab>
    <mat-tab label="Evaluaciones" >

      
        <div class="content p-24" fxLayout="column">

          <div fxLayout="row" fxLayoutAlign="end center" fxFlex class="content p-12" >
            <button  mat-flat-button color="primary" class="add-row" (click)="openDialog()" *ngIf="LOCAL_DATA.evaluaciones.length>0 && isOwnerUser  ">Copiar Evaluaciones</button>
          </div>
          <table mat-table [dataSource]="LOCAL_DATA.evaluaciones" #MatTable class="my-table mat-elevation-z8" >

            <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

            <!-- User Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()"

                              >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)"
                              >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef> Nombre </th>
              <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
            </ng-container>

            <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef> Versión </th>
              <td mat-cell *matCellDef="let element"> {{element.version}} </td>
            </ng-container>
            <ng-container matColumnDef="creador">
              <th mat-header-cell *matHeaderCellDef> Creador </th>
              <td mat-cell *matCellDef="let element"> {{element.creadorName}} </td>
            </ng-container>

            <ng-container matColumnDef="dueno">
              <th mat-header-cell *matHeaderCellDef> Dueño </th>
              <td mat-cell *matCellDef="let element"> {{element.ownerName}} </td>
            </ng-container>

            <ng-container matColumnDef="fechaInicio">
              <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
              <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="fechaFin">
              <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
              <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

        </div>

    </mat-tab>
  </mat-tab-group>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'" [disabled]="LOCAL_DATA.nombre==null || LOCAL_DATA.nombre==''">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
